import i18n from 'dashboard/i18n/instance';
import Auth from '../api/auth';
import { localizeUnauthorizedError } from './unauthorizedError';

const currentLocale = () => i18n.global.locale.value || i18n.global.locale;

const parseErrorCode = error => {
  const apiError = error?.response?.data?.error;
  if (apiError) {
    error.response.data.error = localizeUnauthorizedError(apiError);
  }

  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  wootApi.interceptors.request.use(config => {
    const locale = currentLocale();
    if (locale) {
      config.headers['X-Locale'] = locale;
    }
    return config;
  });
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
